import React, { PureComponent } from "react";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import { showhtml } from "utils/methods";
import {
  message,
} from "antd";
// require("./index.css");
import "./index.scss";

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      entList: []
    };
  }

  componentDidMount = () => {
    Http.getApplication(
      Request.getImportentFirm(),
      {
        current: 1,
        size: 6,
        descs: "recommend",
        auditMechanismType: 0,
        recommend: 1,
      },
      (obj) => {
        if (obj.code == 200) {
          this.setState({
            entList:obj.data.records || []
          })
        } else {
          message.error(obj.msg || obj.message || "请求失败，请重试");
        }
      }
    );
  };

  render() {
    const { entList } = this.state;

    return (
      <div>
        <div className="infoBox" style={{ paddingTop: 30 }}>
          <div className="detailBox">
            <div
              className="backBtn"
              onClick={() => {
                this.props.history.replace("/entrance/home");
                // window.history.back(-1);
              }}
            >
              返回
            </div>
            <div className="title">
              <h2>重点企业推荐</h2>
            </div>
            <div className="recomList">
              {
                entList && entList.length
                ? entList.map((item, index) => {
                    return (
                      <div
                        className="recomItem"
                        key={index}
                        onClick={() =>
                          this.props.history.push(
                            `/entrance/employment/companyDetails/${item.userId}`
                          )
                        }
                      >
                        <div className="point"></div>
                        <div className="name">{item.auditMechanismName}</div>
                      </div>
                    )
                  }):''
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}
